import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";
import AppBarInbox from "./-components/AppBar";

export const Route = createFileRoute("/dashboard/inbox")({
	component: RouteComponent,
});

function RouteComponent() {
	const isShowLayout = useLocation({
		select: (s) =>
			s.pathname === "/dashboard/inbox/alerts" ||
			s.pathname === "/dashboard/inbox/reminders",
	});
	return (
		<div className="relative h-full bg-gray-light flex flex-col">
			{isShowLayout && <AppBarInbox />}
			<Outlet />
		</div>
	);
}
